"use strict";
import { Select } from "@alifd/next";
import React from "react";
import { getPolicyList } from "../../api/application";
import { UISchemaContext } from "../../context";
import i18n from "../../i18n";
import { locale } from "../../utils/locale";
class PolicySelect extends React.Component {
  constructor(props) {
    super(props);
    this.componentDidMount = () => {
      this.fetchPolicyList();
    };
    this.fetchPolicyList = async () => {
      const { appName = "" } = this.context;
      if (appName) {
        getPolicyList({
          appName
        }).then((res) => {
          if (res && res.policies) {
            const policyListData = (res.policies || []).map((item) => {
              return {
                label: `${item.name}(${item.type})`,
                value: item.name
              };
            });
            this.setState({
              policySelectDataSource: policyListData
            });
          } else {
            this.setState({
              policySelectDataSource: []
            });
          }
        }).catch(() => {
          this.setState({
            policySelectDataSource: []
          });
        });
      }
    };
    this.onChange = (value) => {
      const { onChange } = this.props;
      onChange(value);
    };
    this.state = {
      policySelectDataSource: []
    };
  }
  render() {
    const { value, id, disabled } = this.props;
    const { policySelectDataSource } = this.state;
    return /* @__PURE__ */ React.createElement(
      Select,
      {
        placeholder: i18n.t("Please select"),
        onChange: this.onChange,
        id,
        disabled,
        defaultValue: value || [],
        value: value || [],
        dataSource: policySelectDataSource,
        mode: "multiple",
        locale: locale().Select
      }
    );
  }
}
PolicySelect.contextType = UISchemaContext;
export default PolicySelect;
